'use client';

import {Box, Center, Stack} from '@linx-security/ui';
import type {ReactNode} from 'react';

const LoginLayout = ({children}: {children: ReactNode}) => {
  return (
    <Center height={`100vh`}>
      <Stack width={[`100%`, `24rem`, null, null]} alignItems={`center`}>
        <Box
          py={{base: `0`, sm: `8`}}
          px={{base: `4`, sm: `10`}}
          width={`full`}
          display={`flex`}
          justifyContent={`center`}
        >
          {children}
        </Box>
      </Stack>
    </Center>
  );
};

export default LoginLayout;
